module.exports = __webpack_public_path__ + "img/lengjingze.e75597ce.png";